import styled from 'styled-components';
import ChatContainer from './ChatContainer';
import { colorSchema } from 'utils/style';

export default styled(ChatContainer)`
  .chat-container {
    background-color: ${colorSchema('grey200')};
    border-radius: 8px;
    box-shadow: 0 11px 24px 0 rgba(0, 0, 0, 0.17);
    bottom: 2rem;
    display: flex;
    height: 85vh;
    min-height: 536px;
    flex-direction: column;
    position: fixed;
    right: 2rem;
    width: 384px;

    &__header {
      background-color: ${colorSchema('primary500')};
      border-radius: 8px 8px 0 0;
      display: flex;
      padding: 1.6rem 1.6rem 3rem;
      padding: ${props =>
        props.withPadding ? '1.6rem 1.6rem 3rem' : ' 1.6rem'};
    }

    &__close {
      align-items: center;
      background-color: ${colorSchema('grey100')};
      border: 0;
      border-radius: 10.5px;
      cursor: pointer;
      display: flex;
      height: 22px;
      justify-content: center;
      position: absolute;
      right: 0;
      top: -3rem;
      width: 32px;

      svg {
        fill: ${colorSchema('grey900')};
      }
    }

    &__back {
      align-self: center;
      background-color: ${colorSchema('primary500')};
      border: 0;
      border-radius: 4px;
      cursor: pointer;
      margin-right: 1.4rem;
      padding: 0.6rem 0.3rem;

      svg {
        fill: ${colorSchema('white')};
      }

      &:hover {
        background-color: ${colorSchema('primary900')};
      }
    }

    &__header-titles {
      display: flex;
      flex-direction: ${props =>
        props.invertTitles ? 'column-reverse' : 'column'};
      justify-content: center;
    }

    &__title,
    &__subtitle {
      color: ${colorSchema('white')};
      margin: 0;
    }

    &__title {
      font-size: ${props => (props.invertTitles ? '1.5rem' : '1.8rem')};
      font-weight: ${props => (props.invertTitles ? 'bold' : '500')};
      margin-top: ${props => (props.invertTitles ? '0.5rem' : '0')};
    }

    &__subtitle {
      font-size: 1.4rem;
      font-weight: ${props => (props.invertTitles ? 'normal' : '500')};
      margin-top: ${props => (props.invertTitles ? '0' : '0.5rem')};
    }
  }
`;
